import { render, staticRenderFns } from "./CreateRoleTable.vue?vue&type=template&id=34c923e9&scoped=true&"
import script from "./CreateRoleTable.vue?vue&type=script&lang=js&"
export * from "./CreateRoleTable.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoleTable.vue?vue&type=style&index=0&id=34c923e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c923e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCol,VDivider,VRow,VSheet,VSimpleCheckbox,VSkeletonLoader})
